module.exports = __webpack_public_path__ + "img/碧桂园.4a8bc11c.png";